import React from 'react';
import { motion } from 'framer-motion';
export const CTAButton = ({
  children,
  href = 'https://checkout.lmpulsodigital.shop/cart/44544338493575:1',
  className = '',
  fullWidth = false
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}) => {
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center px-8 py-4 
        bg-rose hover:bg-rose-hover text-white font-semibold rounded-full 
        shadow-lg shadow-rose/20 transition-colors duration-300
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-146">
      {children}
    </motion.a>;
};
export const SectionWrapper = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-10 md:py-24 ${className}`} data-id="element-147">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-148">{children}</div>
    </section>;
};
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-149">
      {children}
    </motion.div>;
};